import styled, { css, RuleSet } from "styled-components";
import { pulseDarker } from "../tables/LoadingTableCell";
import { Modal, Placeholder } from "react-bootstrap";
import { AI_GRADIENT } from "../../styles";

export const GradientText = styled.span`
  font-family: "Apercu", system-ui, sans-serif;
  background: ${AI_GRADIENT};
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
`;

export const IconContainer = styled.div<{
  hide?: boolean;
  size?: number;
  p?: number;
  m?: number;
  br?: number;
  bg?: string;
  isLoading?: boolean;
  cursor?: string;
  rotate?: number;
}>`
  display: ${({ hide }): string => (hide ? "none" : "flex")};
  align-items: center;
  justify-content: center;
  border-radius: ${({ br }): number => (br ? br : 50)}%;
  padding: ${({ p }): number => (p ? p : 5)}px;
  margin: ${({ m }): number => (m ? m : 5)}px;
  height: ${(props): number => (props.size ? props.size : 30)}px;
  width: ${(props): number => (props.size ? props.size : 30)}px;
  min-width: ${(props): number => (props.size ? props.size : 30)}px;
  background-color: ${({ bg }): string => (bg ? bg : "transparent")};
  cursor: ${({ cursor }): string => (cursor ? cursor : "normal")};
  ${({ isLoading }): false | RuleSet<object> | undefined =>
    isLoading &&
    css`
      animation: ${pulseDarker} 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    `}
  transform: ${({ rotate }): string =>
    rotate ? `rotate(${rotate}deg)` : "rotate(0deg)"};
`;

export const Icon = styled.img<{ height?: number }>`
  height: ${({ height }): number => (height ? height : 100)}%;
  width: 100%;
`;

export const LegendCircle = styled.div<{ color: string; size?: number }>`
  height: ${({ size }): number => (size ? size : 8)}px;
  width: ${({ size }): number => (size ? size : 8)}px;
  min-width: ${({ size }): number => (size ? size : 8)}px;
  border-radius: 50%;
  background-color: ${({ color }): string => color};
  margin-right: 5px;
`;

export const StyledPlaceholder = styled(Placeholder)<{
  mb?: number;
  ml?: number;
  mt?: number;
}>`
  border-radius: 6px;
  margin-left: ${({ ml }): string => (ml ? `${ml}px` : "0")};
  margin-top: ${({ mt }): string => (mt ? `${mt}px` : "0")};
  margin-bottom: ${({ mb }): string => (mb ? `${mb}px` : "10px")};
`;

export const StyledModalFooter = styled(Modal.Footer)`
  justify-content: center;
`;

export const StyledModalHeader = styled(Modal.Header)``;

export const StyledModal = styled(Modal)`
  .modal-dialog {
    padding: 0px; /* Custom padding */
    border: 0px solid green !important;
  }

  .modal-content {
    padding: 10px; /* Custom padding */
    border: 0px solid green !important;
  }

  .modal-footer {
  }
`;

export const CircleTag = styled(LegendCircle)<{ textColor: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-family: "Apercu";
  font-weight: 800;
  color: ${({ textColor }): string => textColor};
`;
